var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "300", "retain-focus": false },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "navy pa-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "navy white--text d-flex align-center font-hemi-head",
            },
            [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("Scegli calciatore da inserire nello slot selezionato"),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dismiss()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("asta-rosa", {
            staticClass: "pt-4",
            attrs: {
              id_squadra: _vm.id_squadra,
              hideCalciatoriImages: "",
              hideEditRemove: "",
              ripple: "",
              onCalciatoreClick: _vm.associa,
              ruolo_id: _vm.ruolo_id,
              escludi_ids: _vm.associati,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }